import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@atlaskit/button';

import { FormFooter } from '@atlaskit/form';

import { messages } from '../messages';

export type OrganizationSelectorFormFooterProps = {
  readonly canSubmit: boolean;
  readonly onSwitchAccountClick: () => void;
  readonly onCancelClick: () => void;
  readonly fullScreenView?: boolean;
  readonly admin?: boolean;
};

export function OrganizationSelectorFormFooter({
  canSubmit,
  onSwitchAccountClick,
  admin,
  onCancelClick
}: OrganizationSelectorFormFooterProps) {
  return (
    <FormFooter>
      <ActionsContainer>
        <RightActionsContainer>
          {admin ? (
            <div>
              <Button
                appearance="link"
                type="button"
                onClick={() => onSwitchAccountClick()}
              >
                <FormattedMessage {...messages.switchOrgAccount} />
              </Button>
              <PrimaryContainer>
                <Button
                  testId="continueButton"
                  className="continue"
                  appearance="primary"
                  type="submit"
                  isDisabled={!canSubmit}
                >
                  <FormattedMessage {...messages.continue} />
                </Button>
              </PrimaryContainer>
            </div>
          ) : (
            <div>
              <Button
                appearance="link"
                type="button"
                onClick={() => onCancelClick()}
              >
                <FormattedMessage {...messages.dismiss} />
              </Button>
              <PrimaryContainer>
                <Button
                  appearance="primary"
                  type="button"
                  onClick={() => onSwitchAccountClick()}
                >
                  <FormattedMessage {...messages.switchOrgAccount} />
                </Button>
              </PrimaryContainer>
            </div>
          )}
        </RightActionsContainer>
      </ActionsContainer>
    </FormFooter>
  );
}

const ActionsContainer = styled.div`
  margin-top: 8px;
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

const RightActionsContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  text-align: right;
  & > :first-child {
    margin-right: 4px;
  }
`;

const PrimaryContainer = styled.span`
  margin-left: 4px;
`;
